import React from 'react';
import { Select } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { twMerge } from 'tailwind-merge';
import { getCountryOptions } from '@/helpers/countryHelper';

interface IProps {
  value?: string;
  size?: SizeType;
  handleSelectData: (
    id: string,
    country?: {
      label?: string | null;
      value?: string | null;
      code?: string | null;
    } | null,
  ) => void;
  customClassname?: string;
  isAll?: boolean;
  disabled?: boolean;
  isOther?: boolean;
}

const CountrySelector = ({
  value,
  size = 'large',
  handleSelectData,
  customClassname,
  isAll,
  disabled = false,
  isOther,
}: IProps) => {
  const countrys = getCountryOptions();
  const allOption = {
    value: null,
    label: 'ทั้งหมด',
  };

  const other = {
    value: 'OTHER',
    label: 'OTHER',
    code: 'OTHER',
  };

  return (
    <Select
      allowClear
      value={value}
      showSearch
      className={twMerge('md:min-w-[150px]', customClassname)}
      size={size}
      placeholder="เลือก Country"
      disabled={disabled}
      onChange={(v, b) =>
        handleSelectData(
          v,
          b as {
            label?: string | null;
            value?: string | null;
            code?: string | null;
          } | null,
        )
      }
      options={
        isAll
          ? [allOption, ...countrys]
          : isOther
            ? [other, ...countrys]
            : countrys
      }
    />
  );
};

export default CountrySelector;
